import React from "react";
import { ChevronDown } from "lucide-react";

interface MobileSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  ariaLabel?: string;
  children: React.ReactNode;
}

/**
 * Select nativo estilizado: no celular abre o seletor do sistema, que é bem
 * mais confortável que um dropdown custom dentro de um bottom sheet.
 */
export const MobileSelect = ({
  value,
  onChange,
  disabled,
  ariaLabel,
  children,
}: MobileSelectProps) => {
  return (
    <div className="relative">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        aria-label={ariaLabel}
        className="h-11 w-full appearance-none rounded-xl border border-border bg-background px-3 pr-9 text-[15px] text-foreground outline-none transition-colors focus:border-accent-blue disabled:opacity-60"
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
    </div>
  );
};

export const MobileFieldLabel = ({ children }: { children: React.ReactNode }) => (
  <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
    {children}
  </p>
);

export const mobileInputClass =
  "h-11 w-full rounded-xl border border-border bg-background px-3 text-[15px] text-foreground outline-none transition-colors placeholder:text-muted-foreground focus:border-accent-blue";
